module.exports = __webpack_public_path__ + "static/media/2.d2e74f6d.svg";